"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('key', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(6.000000, 7.000000)",
    stroke: props.outStrokeColor,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M16.8682292,17.298 C19.4105469,19.7932732 20.4138066,23.4523269 19.4971338,26.8860485 C18.5804609,30.3197701 15.8844213,33.0016199 12.4325319,33.9134683 C8.98064247,34.8253166 5.30222867,33.8273371 2.79375297,31.2984 C-0.977922831,27.413849 -0.923982562,21.2391607 2.91498715,17.4203961 C6.75395685,13.6016315 12.9613155,13.5479751 16.8664196,17.2998 L16.8682292,17.298 Z",
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("polygon", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    points: "24.305372 9.9 29.7339434 15.3 36.0672768 9 30.6387053 3.6"
  }), _react.default.createElement("path", {
    d: "M34.257753,0 L30.6387053,3.6 L34.257753,0 Z M16.8682292,17.298 L24.305372,9.9 L16.8682292,17.298 Z M24.305372,9.9 L30.6387053,3.6 L24.305372,9.9 Z",
    strokeLinecap: props.strokeLinecap
  })))));
});

exports.default = _default;